import DomainStepsForm from '@/components/Domain/VNNIC/DomainStepsForm'
import useServicePriceTotal from '@/hooks/useServicePriceTotal'
import { Contract, ProductResponse } from '@/modules/Contract/types'
import { useEffect } from 'react'
import { Path, useFormContext, useWatch } from 'react-hook-form'
import { GridHookForm } from 'vnetwork-ui'
import Metadata from '../../../../../../../components/Domain/VNNIC/DomainFormFields/Metadata'
import ServiceTimes from '../../Base/ServiceTimes'

interface VNNICProps {
    index: number
    product: ProductResponse
    isPOC?: boolean
}

const VNNIC: React.FC<VNNICProps> = ({ index, isPOC = false }) => {
    const formControl = useFormContext<Contract>()
    const rootName =
        `order.products.[${index}].service_domain_metadata` as Path<Contract>

    const contract_expiry_date = useWatch({
        control: formControl?.control,
        name: `contract_expiry_date`,
    })

    const contract_effective_date = useWatch({
        control: formControl?.control,
        name: `contract_effective_date`,
    })

    useServicePriceTotal({
        setValue: formControl.setValue,
        index,
        control: formControl.control,
        service_configoptions: [],
    })

    useEffect(() => {
        formControl.setValue(
            `order.products.[${index}].service_times.first_startdate` as Path<Contract>,
            contract_effective_date
        )

        formControl.setValue(
            `order.products.[${index}].service_times.first_enddate` as Path<Contract>,
            contract_expiry_date
        )
    }, [JSON.stringify([contract_expiry_date, contract_effective_date])])

    useEffect(() => {
        formControl.setValue(
            rootName,
            // import.meta.env.DEV
            // ? fakeDataDomainMetadata
            {
                domain_extra_fields: {
                    for: 'canhan',
                },
                dns_option: 'default',
                domain_type: 'register',
                sendmail: true,
            }
        )
    }, [])

    return (
        <div>
            <GridHookForm
                subForm
                actions={[]}
                data={[
                    {
                        renderEditComponent: () => {
                            return (
                                <Metadata
                                    isAddons
                                    isDNS
                                    index={index}
                                    rootName={rootName}
                                />
                            )
                        },
                        className: 'col-span-2',
                    },
                    {
                        renderEditComponent: () => {
                            return <DomainStepsForm rootName={rootName} />
                        },
                        className: 'col-span-2',
                    },
                ]}
                formControl={formControl}
            />

            {!isPOC && (
                <ServiceTimes
                    index={index}
                    disabledStatement
                    datesFromContract
                />
            )}
        </div>
    )
}

export default VNNIC
